import axiosInstance from 'api/axiosInstance';

export interface ContactOption {
	Id: number;
	FullName: string;
}

const searchContacts = async (customerId: number, keyword: string): Promise<ContactOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/SContacts?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=999&CustomerId=${customerId}`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchContacts] Failed:', error);
		throw error;
	}
};

export default searchContacts;
